enum ValueSource {
  CONSTANT = 'CONSTANT',
  CONTEXT = 'CONTEXT'
}

export default ValueSource;
